<div class="card h-100">
  <div>
    <h5><span class="events-title">Kommende Veranstaltungen</span></h5>
    @if (userEvents && userEvents.length === 0) {
      <span class="m-auto"
        ><span class="events-empty-message">Hier haben Sie die Möglichkeit, die Ereignisse zu beobachten.</span></span
        >
      }
      @for (userEvent of userEvents; track userEvent) {
        <div data-tooltip-no-anchor class="mt-2" (click)="PreviewEvent(userEvent)">
          <div class="d-flex event-row pointer">
            <div class="calendar-event">
              <div class="date">{{ userEvent.startDate | date: 'dd' }}</div>
              <div class="month">{{ userEvent.startDate | date: 'MMM' : '' : 'de-DE' | removeDot | uppercase }}</div>
            </div>
            <div class="ml-3 text-wrapper">
              <span class="title event-name">{{ userEvent.name }}</span>
              <div class="event-time">{{ userEvent.startDate | date: 'HH:mm' }} - {{ userEvent.endDate | date: 'HH:mm' }}</div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
